// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"0502748e460e5ed6361d","293":"1720be8ab8552f7f42ab","518":"9424e287de759520c015","779":"ac662cfb053391a875fb"}[chunkId] + ".js";
};